import BagIcon from '@/assets/bag.svg?react';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

interface OrderSummaryLineItem {
  value: string;
  title: string;
  price: number;
}

interface OrderSummaryFormValues {
  document_type: string;
  addons: string[];
}

interface OrderSummaryProps {
  documentTypes: OrderSummaryLineItem[];
  addons: OrderSummaryLineItem[];
}

const OrderSummary = ({ documentTypes, addons }: OrderSummaryProps) => {
  const { i18n } = useLingui();
  const { watch } = useFormContext<OrderSummaryFormValues>();
  const selectedDocumentType = watch('document_type');
  const selectedAddons = watch('addons');

  const lineItems = [
    ...documentTypes.filter(
      (documentType) => documentType.value === selectedDocumentType
    ),
    ...addons.filter((addon) => (selectedAddons ?? []).includes(addon.value)),
  ];
  const total = lineItems.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="flex flex-col gap-3 rounded-md bg-gray-200 p-3.5 md:p-6">
      <div className="flex items-center gap-2">
        <BagIcon width={16} className="text-primary" />
        <p className="h5 text-dark-gray-500">{i18n.t('Twoje zamówienie')}</p>
      </div>
      <div className="flex flex-col gap-3 md:gap-2">
        {lineItems.map((item) => (
          <div
            key={item.value}
            className="caption-large flex items-start justify-between gap-2 text-dark-gray-500"
          >
            <span>{item.title}</span>
            <span className="caption-large-semi shrink-0">{item.price} zł</span>
          </div>
        ))}
        <div className="h-px w-full bg-dark-gray-100" />
        <div className="flex items-center justify-between">
          <p className="h4 text-dark-gray-500">{i18n.t('Razem do zapłaty:')}</p>
          <p className="h4 text-dark-gray-500">{total} zł</p>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
